<p-knob
  [(ngModel)]="timeCron"
  valueTemplate="{value}%"
  [readonly]="true"
  [size]="size"
  valueColor="royalBlue"
></p-knob>
